import { TFunction } from 'i18next';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils/index';
import { camelCase } from 'lodash';

export function priceTitle(t: TFunction, criteria: ListingSearchCriteria) {
  const { minPrice, maxPrice } = criteria.priceFilter();
  if (minPrice && !maxPrice) {
    return t('filters:price:titleWithMinOnly', { minPrice });
  }
  if (maxPrice && !minPrice) {
    return t('filters:price:titleWithMaxOnly', { maxPrice });
  }
  if (minPrice && maxPrice) {
    return t('filters:price:titleWithRange', { minPrice, maxPrice });
  }
  return t('filters:price:title');
}

export function sizeTitle(t: TFunction, criteria: ListingSearchCriteria) {
  const { minSize, maxSize } = criteria.sizes();
  if (minSize && !maxSize) {
    return t('filters:size:titleWithMinOnly', { minSize });
  }
  if (maxSize && !minSize) {
    return t('filters:size:titleWithMaxOnly', { maxSize });
  }
  if (minSize && maxSize) {
    return t('filters:size:titleWithRange', { minSize, maxSize });
  }
  return t('filters:size:title');
}

export function spaceConditionTitle(t: TFunction, criteria: ListingSearchCriteria) {
  switch (criteria.spaceConditions().length) {
    case 1: {
      const conditionKey = camelCase(criteria.spaceConditions()[0]);
      return t(`filters:spaceCondition:${conditionKey}`);
    }
    case 0: {
      return t(`filters:spaceCondition:title`);
    }
    default: {
      return t(`filters:spaceCondition:multipleOptionsTitle`, {
        numSelected: criteria.spaceConditions().length,
      });
    }
  }
}

const termToTranslationKey = {
  '<1': '1orLessTitle',
  '1-3': '1to3Title',
  '3-5': '3to5Title',
  '5-10': '5to10Title',
  '10-15': '10to15Title',
};

export function termTitle(t: TFunction, criteria: ListingSearchCriteria) {
  switch (criteria.terms().length) {
    case 1: {
      const conditionKey = termToTranslationKey[criteria.terms()[0]];
      return t(`filters:term:${conditionKey}`);
    }
    case 0: {
      return t(`filters:term:title`);
    }
    default: {
      return t(`filters:term:multipleOptionsTitle`, {
        numSelected: criteria.terms().length,
      });
    }
  }
}

export function leaseTypeTitle(t: TFunction, criteria: ListingSearchCriteria) {
  switch (criteria.leaseTypes().length) {
    case 1: {
      const leaseType = criteria.leaseTypes()[0];
      return t(`filters:leaseType:${leaseType}`);
    }
    case 0: {
      return t(`filters:leaseType:title`);
    }
    default: {
      return t(`filters:leaseType:multipleOptionsTitle`, {
        numSelected: criteria.leaseTypes().length,
      });
    }
  }
}
